import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {SceneName} from "@/model/scene-name";
import {CreatureUtils} from "@/utils/creature-utils";
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import PlayerStore from "@/store/player";

export class MenuCreaturesNavPanel extends AbstractNavPanel {
    public name: string = "";
    public static MAX_CREATURES_NO_ARROWS: number = 6;

    private onCreaturePanelPressCallback: (sceneName: SceneName, params: any) => void;
    private creatures!: Creature[];

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, creatures: Creature[],
                onCreaturePanelPressCallback: (sceneName: SceneName, params: any) => void, maxDisplayedElements: number) {
        super(scene, canvas, x, y, creatures, maxDisplayedElements);

        this.creatures = creatures;
        this.onCreaturePanelPressCallback = onCreaturePanelPressCallback;

        this.setDepth(1000);

    }

    protected makePanel(x: number, element: any): any {

        let creaturePanel = new CreaturePanel(this.scene!, x, this.getPanelShiftY(), <Creature>element, () => undefined, true);
        creaturePanel.setDepth(1000);
        SpriteUtils.scale(creaturePanel, this.getPanelScale() / CU.S, this.getPanelScale() / CU.S);

        creaturePanel.setCallback(() => {
            if (this.onCreaturePanelPressCallback != null) {
                this.playSelectSound();

                // Собираю массив постоянных и сортирую
                let crs = CreatureUtils.sortCreaturesDescending(CreatureUtils.findNonTemporalCreatures(PlayerStore.getPlayer().creatures));              

                let creatureIndex = -1;

                // Если юнит временный - ищу последнего возможного постоянного (скорее всего это мужик)
                if (creaturePanel.getCreature().temporal) {
                    creatureIndex = crs.length - 1;
                } else {
                    crs.forEach((c: Creature, index:number) => { if (c.id === creaturePanel.getCreature().id) creatureIndex = index });
                }

                this.onCreaturePanelPressCallback(SceneName.CREATURE_SCENE, { creatureIndex: creatureIndex});

            }
        });

        return creaturePanel;

    }

    protected getButtonX(): number {
        return 140;
    }

    protected getButtonY(): number {
        return 20;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return creaturesAmount >= MenuCreaturesNavPanel.MAX_CREATURES_NO_ARROWS ? 54 : 60;
    }

    private getPanelShiftY(): number {
        return this.elementsCount >= MenuCreaturesNavPanel.MAX_CREATURES_NO_ARROWS ? 36 : 31;
    }

    private getPanelScale(): number {
        return this.elementsCount >= MenuCreaturesNavPanel.MAX_CREATURES_NO_ARROWS ? 0.56 : 0.6;
    }
}
